/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsfilterlabel2Inputs */

const en_earningsfilterlabel2 = /** @type {(inputs: Earningsfilterlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which events`)
};

const de_earningsfilterlabel2 = /** @type {(inputs: Earningsfilterlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Events`)
};

/**
* | output |
* | --- |
* | "Which events" |
*
* @param {Earningsfilterlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsfilterlabel2 = /** @type {((inputs?: Earningsfilterlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsfilterlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsfilterlabel2(inputs)
	return de_earningsfilterlabel2(inputs)
});
export { earningsfilterlabel2 as "earningsFilterLabel" }